export const nullReducer = (state = {}, action) => state;

export function getHandler(handlers, actionType) {
  return handlers.hasOwnProperty(actionType) ? handlers[actionType] : nullReducer;
}

export function createReducer(initialState, handlers) {
  return (state = initialState, action) => getHandler(handlers, action.type)(state, action);
}
